import { useTranslation } from "react-i18next";
import Button from "components/Button";

interface ProductUsageSaveFooterProps {
  onCancel: () => void;
  onSave: () => void;
}

const ProductUsageSaveFooter = ({
  onCancel,
  onSave,
}: ProductUsageSaveFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex py-4 px-6 justify-end items-center bg-gray-50 border-t border-gray-200 gap-4">
      <Button type="gray" onClick={onCancel}>
        {t("commons.cancel")}
      </Button>
      <Button onClick={onSave}>{t("productEditor.saveProduct")}</Button>
    </div>
  );
};

export default ProductUsageSaveFooter;
